module.exports = __webpack_public_path__ + "img/PAI_Landing-Page_Desktop_12.dd361662.jpg";